import { defineComponent } from "@openuidev/lang-core";
import { z } from "zod";

// Widgets every subject uses. See ../widgets.ts for the rules all widgets follow.

export const Text = defineComponent({
  name: "Text",
  description: "A short paragraph of tutor text. Keep it to one or two sentences for children.",
  props: z.object({
    text: z.string().min(1).max(600),
  }),
  component: null,
});

export const ChoiceQuestion = defineComponent({
  name: "ChoiceQuestion",
  description:
    "Shows the current exercise's multiple-choice question so the child can answer it here. Give only the exercise id from the operator note; the app shows the engine's prompt and choices. Use it only for the current exercise, never for another or an invented one.",
  // A reference, not content: the prompt and choices come from the engine's
  // `item.presented` event, so the model can neither reorder or invent choices (which
  // would corrupt grading by index) nor present an item the engine did not pick.
  props: z.object({
    itemId: z.string().min(1).max(64),
  }),
  component: null,
});

/** Longest step Coach may write on the board (ADR-0052, step B2). */
export const MAX_BOARD_STEP = 160;

export const BoardStep = defineComponent({
  name: "BoardStep",
  description:
    "One step written on the board above the exercise, when you explain, show a step or demonstrate (Explain, Show, Demonstrate). Write the next step only, one short sentence with its numbers, as a teacher writes on a board; the board numbers the steps. Never the exercise's answer. Send it alone in its block, and keep talking to the child in your text.",
  // Plain text only: the engine decides whether it goes on the board (`placeStep`), and the
  // answer-leak gate reads it at the reply's hint level like the rest of the reply.
  props: z.object({
    text: z.string().trim().min(1).max(MAX_BOARD_STEP),
  }),
  component: null,
});

export const coreWidgets = [Text, ChoiceQuestion, BoardStep] as const;
